import type { IOpenQuestion, IUpdateOpenQuestion } from '@condo/domain';
import { omit } from 'lodash-es';
import { getClient } from '../api-client';

export const fetchOpenQuestionOfAMfh = async (mfhId: number): Promise<IOpenQuestion[]> =>
    getClient('basecamp')
        .get('/open-question', {
            params: {
                mfhId,
            },
        })
        .then(response => response.data.openQuestions);

export const createOpenQuestion = async (body: IOpenQuestion): Promise<IOpenQuestion> =>
    getClient('basecamp')
        .post('/open-question', body)
        .then(response => response.data);

export const updateOpenQuestion = async (openQuestionId: number, body: IUpdateOpenQuestion): Promise<IOpenQuestion> =>
    getClient('basecamp')
        .put(`/open-question/${openQuestionId}`, omit(body, 'openQuestionId'))
        .then(response => response.data);

export const deleteOpenQuestions = async (openQuestionIds: number[]): Promise<void> =>
    getClient('basecamp')
        .delete(`/open-question`, {
            data: {
                openQuestionIds,
            },
        })
        .then(response => response.data);
